const draftStatusOptions = [
  { value: "InProgress", label: "In Progress" },
  { value: "ReadyForSupervisor", label: "Ready For Supervisor" },
  { value: "Exported", label: "Exported" },
  { value: "Completed", label: "Completed" },
];

const distanceOptions = [
  { value: "10000", label: "Any" },
  { value: "10", label: "10" },
  { value: "15", label: "15" },
  { value: "20", label: "20" },
  { value: "25", label: "25" },
  { value: "30", label: "30" },
  { value: "40", label: "40" },
  { value: "50", label: "50" },
  { value: "75", label: "75" },
  { value: "100", label: "100" }
];

const hourOptions = [
  { value: "0", label: "Any" },
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
  { value: "6", label: "6" },
  { value: "7", label: "7" },
  { value: "8", label: "8" },
  { value: "9", label: "9" },
  { value: "10", label: "10" },
  { value: "11", label: "11" },
  { value: "12", label: "12" },
  { value: "13", label: "13" },
  { value: "14", label: "14" },
  { value: "15", label: "15" },
  { value: "16", label: "16" },
  { value: "17", label: "17" },
  { value: "18", label: "18" },
  { value: "19", label: "19" },
  { value: "20", label: "20" },
];

const defaultHandleInputChange = function(e) {
  const { value, name } = e.target;
  this.setState({
    [name]: value
  });
};

const defaultHandleCheckboxChange = function(e) {
  const { checked, name } = e.target;
  this.setState({
    [name]: checked
  });
};

export {
  draftStatusOptions,
  distanceOptions,
  hourOptions,
  defaultHandleInputChange,
  defaultHandleCheckboxChange
};
